module.exports = __webpack_public_path__ + "static/theoryOfChange-e4baa3c3c83c2c025165c32c38d5becb.jpg";